import { render } from "./Businesstypeanalytics.vue?vue&type=template&id=1b139de1&scoped=true"
import script from "./Businesstypeanalytics.vue?vue&type=script&lang=js"
export * from "./Businesstypeanalytics.vue?vue&type=script&lang=js"

import "./Businesstypeanalytics.vue?vue&type=style&index=0&id=1b139de1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b139de1"]])

export default __exports__